export abstract class DateTimeHelper {
    public static addDays(date, numberOfDays) {
        const returnDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + numberOfDays,
            date.getHours(),
            date.getMinutes(),
            date.getSeconds());
        return returnDate;
    }

    public static getMonthStartDate() {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        return firstDay;  
    }

    public static currentDate(date?): string {
        if (!date && typeof (date) !== 'function') {
            date = new Date();
        }
        let month = (date.getMonth() + 1).toString();
        if (Number(month) < 10) {
            month = '0' + month;
        }

        let day = (date.getDate()).toString();
        if (Number(day) < 10) {
            day = '0' + day;
        }

        const d = `${date.getFullYear()}-${month}-${day}`;
        return d;
    }

    public static formatDate(date): string {
        if (!date) { return null; }
        const [year, month, day] = date.split('-');
        return `${month}-${day}-${year}`;
    }
}
